import OverlayIcon from 'Components/GMS/Rules/Components/OverlayIcon';
import React from 'react';
import { tooltips } from '../utils/ABHelper';

type TCustomRadioButtonProps = {
    list: string[];
    showOverlayIcon?: boolean;
    selectedItem: string;
    setSelectedItem: (value: string) => void;
};

const CustomRadioButton = ({ list, showOverlayIcon = false, selectedItem, setSelectedItem, }: TCustomRadioButtonProps) => {

    const handleItemChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedItem(event.target.value);
    };

    return (
        <div className="tw-flex tw-space-x-4 tw-mt-1 tw-mb-3">
            {list?.map((item) => {
                const tooltipMessage = tooltips[item] || '';
                const metricId = `fruit-${item.toLowerCase()}`;
                return (
                    <div key={item} className="tw-inline-flex tw-items-center tw-gap-2">
                        <input
                            type="radio"
                            id={metricId}
                            value={item}
                            checked={selectedItem === item}
                            onChange={handleItemChange}
                            className="tw-form-radio tw-h-4 tw-w-4 tw-text-[#091CAA] tw-cursor-pointer"
                        />
                        <label htmlFor={metricId} className="tw-cursor-pointer tw-text-sm tw-text-[#172B4D]">
                            {item}
                        </label>
                        {showOverlayIcon ? <OverlayIcon message={tooltipMessage} /> : null}
                    </div>
                );
            })}
        </div>
    );
};

export default CustomRadioButton;
